import React, { Component, useEffect, useState } from 'react';
import {
  Tooltip,
  OverlayTrigger,
  Button
} from "react-bootstrap";
import { musicDirectorActions } from 'redux/actions/music-director-action';
import { festivalActions } from 'redux/actions/festival-action';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import editicon from "assets/img/edit.png";
import Select from 'react-select';
import ReactLoading from 'react-loading';
import Wavesurfer from 'react-wavesurfer';
import play from "assets/img/play.png";
import pause from "assets/img/pause.png";
import Profile_Icon from "assets/img/Profile-Icon.png";
import $ from 'jquery';
import TranscribeForm from "./TranscribeForm";
window.WaveSurfer = require("wavesurfer.js");
var dateFormat = require('dateformat');
var moment = require("moment");
// done remove momentDurationFormatSetup for warning optimization
var momentDurationFormatSetup = require("moment-duration-format");
var isEqual = require('lodash.isequal');
var FileSaver = require('file-saver');
var JSZip = require('jszip');
var JSZipUtils = require('jszip-utils');
var Modal = require('react-bootstrap-modal');

class DashboardPage extends Component{
  constructor(props){
    super(props);

    const { festivalId } = this.props.match.params;
    this.state = {
      editCommentObject  : null,
      editModalCommentTemp  : false,
      adjudicators:[],
      page:0,
      festivalId : festivalId,
      total_page:0,
      recordings:[],
      festivalComments:[],
      countRecording:0,
      selectedOption: null,
      optionsState: null,
      // currentSelectedIndex: null,
      musicDirector :{
        musicDirector_id:this.props.musicDirector.id,
        username:this.props.musicDirector.username,
        request_type:'web'
      },
      selectedAdjudicatorRecording:{
        musicDirector_id:this.props.musicDirector.id,
        adjudicator_id:'',
        request_type:'web'
      },
      playing:[],
      pos:[],
      durationAudio:[],
      recordingNotFound:true,
      getRecordingApi:false
    };
    this.handleChange       = this.handleChange.bind(this);
    this.handleChangeMD     = this.handleChangeMD.bind(this);
    this.updateCommentConfirm = this.updateCommentConfirm.bind(this);
    this.updateCommentMusicDirector      = this.updateCommentMusicDirector.bind(this);
    this.handleTogglePlay   = this.handleTogglePlay.bind(this);
    this.handlePosChange    = this.handlePosChange.bind(this);
    this.handleFinish       = this.handleFinish.bind(this);
    this.handleLoadingAudio = this.handleLoadingAudio.bind(this);
    this.getNextPageData    = this.getNextPageData.bind(this);
    this.showAllComments    = this.showAllComments.bind(this);
    this.downloadFile       = this.downloadFile.bind(this);
    this.downloadAllFiles   = this.downloadAllFiles.bind(this);
    this.openModalCommentTempEdit 	= this.openModalCommentTempEdit.bind(this);
    this.closeModalCommentTempEdit 	= this.closeModalCommentTempEdit.bind(this);
    this.handleCommentSubmit  	= this.handleCommentSubmit.bind(this);
    this.approvedHandle  	= this.approvedHandle.bind(this);
  };

  openModalCommentTempEdit(commentObj){
    this.setState({editCommentObject:commentObj}, function(){
      this.setState({editModalCommentTemp:true});
    });
  }
  closeModalCommentTempEdit(){
    this.setState({editCommentObject:null}, function(){
      this.setState({editModalCommentTemp:false});
    });
  }

  urlToPromise(url) {
    return new Promise(function(resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
          if(err) {
              reject(err);
          } else {
              resolve(data);
          }
      });
    });
  }
  downloadAllFiles(){
    var zip   = new JSZip();

    const { selectedOption } = this.state;
    const recordingTemp = {...this.state.recordings};

    var recordingTempKeys = Object.keys(recordingTemp);
    var recordingTempLen = recordingTempKeys.length;

    this.state.recordings.map((prop,key)=>{
      this.urlToPromise(prop['comment_url']);
      // console.log('comments url',prop['comment_url']);
      //JSZipUtils.getBinaryContent(prop['comment_url'], function (err, data){
        //if(err) {
          //throw err;
        //}

        var extension = null;
        if(prop['comment_url'].includes('.mp4'))
          extension = '.mp4';
        if(prop['comment_url'].includes('.m4a'))
          extension = '.m4a';

        if (extension) {
          var temp = key+1;
          // console.log('test', temp+extension);
          zip.file(temp+extension, this.urlToPromise(prop['comment_url']), {base64:true,binary:true});
          extension = null;
        }
        if(key+1 === recordingTempLen){
          // console.log('if key', key);
          zip.generateAsync({type:"blob"})
          .then(function(content) {
            FileSaver.saveAs(content, selectedOption?selectedOption['first_name'].concat('_', selectedOption['last_name']):'All'+".zip");
          });
        }
      //});
    });

    // console.log('test');
  }
  downloadFile(recUrl, adjudicatorName) {
    var extension = null;
    if(recUrl.includes('.mp4'))
      extension = '.mp4';
    if(recUrl.includes('.m4a'))
      extension = '.m4a';
    FileSaver.saveAs(recUrl,adjudicatorName+extension);
  }
  showAllComments(){
    const adjudicatorRecordings = {...this.state.selectedAdjudicatorRecording};
    adjudicatorRecordings['adjudicator_id'] = '';
    this.setState({selectedAdjudicatorRecording: adjudicatorRecordings}, function(){
      this.setState({selectedOption: null}, function(){
        this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, 1);
      });
    });
  }
  getNextPageData(page){
    // console.log(page);
    this.props.getFestivalComments(this.state.festivalId, page);
  }
  handleLoadingAudio(e, num){
    const durationTemp = {...this.state.durationAudio};
    durationTemp[num] = e.wavesurfer.backend.buffer.duration;
    this.setState({durationAudio:durationTemp});
  }
  handleFinish(e, num){
    const playingTemp = {...this.state.playing};
    playingTemp[num] = false;
    this.setState({playing: playingTemp}, function(){
      const posTemp = {...this.state.pos};
      posTemp[num] = 0;
      this.setState({pos: posTemp});
    });
  }
  handleTogglePlay(num) {
    const playingTempNew = {...this.state.playing};

    var playingTempNewKeys = Object.keys(playingTempNew);
    var playingTempNewLen = playingTempNewKeys.length;

    for(var i = 0 ; i < playingTempNewLen; i++){
      if (playingTempNew[i] && (i !== num) ){
        playingTempNew[i] = false;
      }
    }

    this.setState({playing: playingTempNew}, function(){
      const playingTemp = {...this.state.playing};
      playingTemp[num] = !playingTemp[num];
      this.setState({playing: playingTemp});
    });
  }
  handlePosChange(e, num) {
    const posTemp = {...this.state.pos};
    posTemp[num] = e.originalArgs[0];
    this.setState({pos: posTemp});
  }
  handleChangeMD(current_musicDirectorId, id, info){
    if(current_musicDirectorId != info.id){
      this.updateCommentConfirm(id,info);
    }
  }
  updateCommentMusicDirector(id,info){
    this.props.updateCommentMusicDirector(info, id);
  }


  handleCommentSubmit(data, formType){
      this.props.editCommentCall(data, data.id).then(response => {
          this.setState({'editModalCommentTemp' : false}, function(){
            // this.props.getCommentsCall();
            this.props.getFestivalComments(this.state.festivalId, 1)
            let tp = $('#alert').offset().top;
            $('body, html').animate({scrollTop: tp})

          })
      }, error=> {
      });
  }

  updateCommentConfirm(id,info){
  	confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Update Festival Comment</h3>
              <p className="marginFromTopPopUp" >Are you sure you want to assign this comment to different music director? </p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.updateCommentMusicDirector(id, info)
                    onClose()
                }}>Yes</button>
              </div>
            </div>

          </div>
        )
      }
    })
  }
  handleChange(selectedOption) {
    this.setState({ selectedOption }, function(){
      // if ( selectedOption ) {
        const adjudicatorRecordings = {...this.state.selectedAdjudicatorRecording};
        adjudicatorRecordings['adjudicator_id'] = selectedOption?selectedOption.id:'';

        this.setState({selectedAdjudicatorRecording: adjudicatorRecordings}, function(){
          this.setState({recordings:[]}, function(){
            this.setState({playing:[]}, function(){
              this.setState({durationAudio: []}, function(){
                this.setState({pos:[]}, function(){
                  this.setState({page:0}, function(){
                    this.setState({total_page:0}, function(){
                      this.setState({countRecording:0}, function(){
                        this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, 1);
                      })
                    })
                  })
                });
              });
            });
          });
        });
      // }
    });

  }

  componentWillReceiveProps(nextProps) {

    // if (nextProps.adjudicators && !isEqual(this.state.adjudicators, nextProps.adjudicators)){
    //   this.setState({adjudicators:nextProps.adjudicators});
    // }

    if (this.props.festivalComments !== nextProps.festivalComments){
        if ( nextProps.festivalComments.data) {
        /*Logic to compare old data with new not to render again and for lazy loading data push to end of an array*/
        var festivalCommentsTempKeys = Object.keys(nextProps.festivalComments.data);

        var festivalCommentsTempLen = festivalCommentsTempKeys.length;

        var currentRecordingKeys = Object.keys(this.state.festivalComments);

        var currentRecordingCount = currentRecordingKeys.length;

        var countTempNewNext = 0;

        if (nextProps.festivalComments.current_page === 1){
          countTempNewNext = festivalCommentsTempLen;
        } else {
          var multi = (nextProps.festivalComments.current_page - 1) * nextProps.festivalComments.per_page;
          countTempNewNext = festivalCommentsTempLen + multi;
        }

        if ( countTempNewNext === 0 ){
          this.setState({getRecordingApi:true}, function(){
            this.setState({recordingNotFound:true});
          });
        } else {
          this.setState({getRecordingApi:true}, function(){
            this.setState({recordingNotFound:false});
          });
        }

        // ......state update after toggle change.......//
        if (this.state.festivalComments.length > 0) {
            var festivalCommentsTemp = this.state.festivalComments;
            festivalCommentsTemp= [];
            for(var i = 0 ; i < festivalCommentsTempLen; i++){
                festivalCommentsTemp.push(nextProps.festivalComments.data[i]);
            }
            this.setState({
                festivalComments:festivalCommentsTemp
            })
        }
        // .............//

        /*If count is not equal for old recording state and to next prop then it will update recording state*/
        if (!isEqual(currentRecordingCount, countTempNewNext)){
          const festivalCommentsTemp = this.state.festivalComments;
          const playingTempInitial = {...this.state.playing};
          const durationAudioTemp = {...this.state.durationAudio};
          const posTemp = {...this.state.pos};

          var countTemp = this.state.countRecording;

          for(var i = 0 ; i < festivalCommentsTempLen; i++){
            festivalCommentsTemp.push(nextProps.festivalComments.data[i]);
            playingTempInitial[countTemp] = false;
            durationAudioTemp[countTemp] = 0;
            posTemp[countTemp] = 0;
            countTemp++;
          }

          this.setState({playing:playingTempInitial}, function(){
            this.setState({durationAudio: durationAudioTemp}, function(){
              this.setState({pos:posTemp}, function(){
                this.setState({festivalComments:festivalCommentsTemp},  function(){
                  this.setState({countRecording:countTemp}, function(){
                    this.setState({page:nextProps.festivalComments.current_page}, function(){
                      this.setState({total_page:nextProps.festivalComments.last_page});
                    });
                  });
                });
              });
            });
          });
        }
      }
    }
  }
  componentDidMount() {
    // this.props.getAdudicatorsCall(this.state.musicDirector);
    this.props.getFestivalComments(this.state.festivalId, 1);
    this.props.getFestivalMusicDirectors(this.state.festivalId);
    this.showAllComments();
    this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, 1);
  }
  approvedHandle(e, comment_id, num) {

    let isTextApproved = e.target.checked;
    let data = {is_text_approved: isTextApproved};

    this.props.editCommentCall(data, comment_id).then(response => {
        this.props.getFestivalComments(this.state.festivalId, 1)
        let tp = $('#alert').offset().top;
            $('body, html').animate({scrollTop: tp})

    });


  }

  render(){
    const { editModalCommentTemp, editCommentObject, selectedOption, adjudicators, festivalComments, durationAudio, pos, playing, page, total_page, recordingNotFound, getRecordingApi} = this.state;

    const { loading, musicDirector, users, festival } = this.props;
    return(
      <section className="clearfix custom_content">
        <div className="">
          <div className="">
            <div className="col-md-12">
              <h2 className="gallery_title text-center">Comments Listing</h2>
            </div>
            <div className="col-md-12">
              <div className="comments_container">
                {
                  festival&&
                  <div className="all_comments">
                    {festival.name}

                    {
                      // !recordingNotFound &&
                      // <button className="download_all" onClick={this.downloadAllFiles} >download all</button>
                    }
                    <div className="clearfix"></div>
                  </div>
                }

                {
                  festivalComments &&
                  <div>

                    {
                      festivalComments.map((prop,key)=>{
                        // let currentKey = key
                        // console.log('currentKey', currentKey, prop)
                        return (
                          <div  className="audio_comment small_comment" key={key}>

                            <div className="user_details">
                            {

                              <img src={prop.adjudicator.image_url?prop.adjudicator.image_url:Profile_Icon} alt="ProfileIconImage" />
                            }

                            <p className="comment_name">{prop.adjudicator.first_name +' '+ prop.adjudicator.last_name}</p>
                            </div>
                            <div className="play" durationtest={durationAudio[key]} position={pos[key]}>
                                {
                                  !playing[key] &&
                                  <button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={play} alt="playImage" /></button>
                                }
                                {
                                  playing[key] &&
                                  <button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={pause} alt="pauseImage" /></button>
                                }
                            </div>

                            <div className='commentOuterWrapper'>
                              <div className="audio_player">
                                <div className="dated">{   moment( moment.utc(prop.created_at).toDate()).local().format('MM/DD/YYYY HH:mm:ss')   } </div>
                                {
                                    prop.comment_url &&
                                  <Wavesurfer
                                    audioFile={prop.comment_url}
                                    pos={pos[key]}
                                    onPosChange={(e)=>this.handlePosChange(e, key)}
                                    playing={playing[key]?true:false}
                                    crossorigin="anonymous"
                                    onFinish={(e)=>this.handleFinish(e, key)}
                                    onReady={(e)=>this.handleLoadingAudio(e,key)}
                                    options= {{height: 65,waveColor: '#e1f0f0',progressColor: '#bcd7e0',cursorColor: '#a3c6cf', width:'100%'}}
                                  />
                                }
                                <div className="timer_en" test={durationAudio[key]}>{ moment.duration(durationAudio[key], "seconds").format() }</div>
                                {
                                  pos[key] >= 1 &&
                                  <div className="timer_st">{ moment.duration(pos[key], "seconds").format() }</div>
                                }
                                {
                                  pos[key] < 1 &&
                                  <div className="timer_st">0:00</div>
                                }
                              </div>
                              <div className='commentWrapper'>
                                <div className="musicDirector_container">
                                  {
                                    users &&
                                    <Select
                                      value={ { id: prop.music_director.id , display_name: prop.music_director.display_name } }
                                      options={users}
                                      onChange={(e) => this.handleChangeMD(prop.music_director.id, prop.id, e)}

                                      getOptionLabel ={(option)=>option.display_name}
                                      getOptionValue ={(option)=>option.id}
                                      className="selectAdjudicator"
                                      placeholder="Select Music Director"
                                      // isClearable={true}
                                      isMulti={false}
                                      apple={'mango'}
                                    />
                                  }
                                </div>
                                {
                                  prop.comment_json_path &&
                                  <div className="directorApprove">
                                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Comments</Tooltip>}>
                                      <Button className="actionEditButton"  onClick={()=>this.openModalCommentTempEdit(prop)}><img src={editicon} alt="Edit Transcription" width={14}/> Update Text Comments</Button>
                                    </OverlayTrigger>

                                    <div className="mr-md1 directorchecked">
                                        <div className="text_16 mr-sm">
                                            Approve Transcription For Directors
                                        </div>
                                        <div style={{marginLeft:'auto'}}>
                                            <input type="checkbox" onChange={e => this.approvedHandle(e, prop.id, key)} id={`switch-${key}`} value={prop.is_text_approved == 1 ? 1 : 0} checked={prop.is_text_approved == 1 ? 1 : 0} className="cssSwitch" /><label className="cssSwitch" htmlFor={`switch-${key}`}>Toggle</label>
                                        </div>
                                    </div>
                                  </div>
                                }
                                {
                                  !prop.comment_json_path &&
                                  <div className="directorApprove">
                                    <div className="mr-md1 directorchecked">
                                        <div className="text_16 mr-sm">
                                        {/* FaExclamationTriangle */}

                                        <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Please refresh this page after a while as the text commentary is being generating.</Tooltip>}>
                                          <i className="fa fa-exclamation-triangle" style={{color:"tomato", fontSize:"30px"}}></i>
                                        </OverlayTrigger>




                                        </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>

                            {/* <button style={{'display': 'none'}} className="download_btn" onClick={()=>this.downloadFile(prop.comment_url, prop.adjudicator.first_name.concat('_',prop.adjudicator.last_name,'_', key+1))}>download</button>

                            <div style={{width:'100%' }}></div> */}

                          </div>
                        )
                      })
                    }
                  </div>
                }
              </div>
              <div style={{textAlign:'center'}}>
                {
                  page < total_page  &&
                  <button className="load_more_btn" onClick={()=>this.getNextPageData(this.state.page+1)} >Load More</button>
                }
                {
                  !loading && recordingNotFound && getRecordingApi &&
                  <div>
                    <div className="clearfix" ></div>
                    <div className="well well-sm" style={{marginTop:'15px'}}>
                      <h3>Comments Not Found!</h3>
                    </div>
                  </div>
                }

                { loading &&
                  <ReactLoading type="bars" color="#1DC7EA" height={5} width={40} />
                }
              </div>
            </div>
          </div>
        </div>

        {/*Edit Comment Template Start*/}
        {
          editCommentObject &&
          <Modal show={editModalCommentTemp } onHide={this.closeModalCommentTempEdit} aria-labelledby="ModalHeader" >
              <Modal.Header closeButton>
                <Modal.Title id='ModalHeader'>Edit Comments</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <div className="row">
                    <div className="col-md-12">
                        <TranscribeForm
                          commentObject= {{...editCommentObject}}
                          formType='edit'
                          handleCommentSubmit = { this.handleCommentSubmit }
                          handleTogglePlay = { this.handleTogglePlay }
                          buttonName="Update"
                        />
                    </div>
                  </div>
              </Modal.Body>
            </Modal>
        }
        {/*Edit Comment Template End*/}

      </section>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return ({
    // getAdudicatorsCall  : (musicDirectorData) => { dispatch(musicDirectorActions.getAdudicators(musicDirectorData)) },
    getFestivalComments  : (festivalId, page) => { dispatch(festivalActions.getFestivalComments(festivalId, page)) },
    getFestivalMusicDirectors  : (festivalId) => { dispatch(festivalActions.getFestivalMusicDirectors(festivalId)) },
    getAdudicatorsRecordingsCall  : (adjudicatorRecordingsObject, page) => { dispatch(musicDirectorActions.getAdudicatorsRecordings(adjudicatorRecordingsObject, page)) },
    updateCommentMusicDirector  : (info, id) => { dispatch(festivalActions.updateComment(info, id)) },
    editCommentCall: (data, id) => {return dispatch(festivalActions.updateCommentData(data, id)) }
  });
};

function mapStateToProps(state) {
  const { adjudicators, loading, musicDirector, recordings } = state.musicDirectorReducer;
  const { users, festivalComments, festival } = state.festivalReducer;
  console.log('is_text_approved ', festivalComments && festivalComments.data && festivalComments.data[0] && festivalComments.data[0].is_text_approved);
  return {
    adjudicators,loading, musicDirector, recordings, users, festivalComments, festival
  };
}

const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Admin/Comments.jsx